<app-top-nav class="force-dark-theme" />

<as-split
  class="sidenav-container"
  unit="pixel"
  [restrictMove]="true"
  [useTransition]="true"
  [class.sidenav-over]="isOver()"
  (dragEnd)="onSplitterDragEnd($event)"
>
  <as-split-area class="sidenav" [size]="sidenavSize" [minSize]="minSize" [visible]="open()">
    <router-outlet name="sidenav" />
  </as-split-area>
  <as-split-area size="*" [minSize]="minSize" class="sidenav-content" role="main">
    <router-outlet />
    @if (isOver()) {
      <div class="overlay" (click)="onOverlayClick($event)"></div>
    }
  </as-split-area>
</as-split>

<app-footer class="force-dark-theme" />
